import { render, staticRenderFns } from "./DialogRegister-v2.vue?vue&type=template&id=aebdcaa4"
import script from "./DialogRegister-v2.vue?vue&type=script&lang=js"
export * from "./DialogRegister-v2.vue?vue&type=script&lang=js"
import style0 from "./DialogRegister-v2.vue?vue&type=style&index=0&id=aebdcaa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports